// views/chat-builder/replyStyles.js
// 학습자 말 받아 주기 — 서버 SERVER/chat-core/block/replyStyles.js 의 **미러**(축·선택지·라벨).
// 서버에 선택지를 추가·삭제하면 여기도 같이 고친다(서버 modifyChat 은 모르는 선택지를 버린다).
//
// 축 = "사용자가 이렇게 답하면 어떻게 받을지". 유도 방식(막혔을 때 무엇을 주나)·유도문형(언제 개입하나)과 다른 축이다.
// 해소: 축마다 스텝 completion.reply → 챗 기본값 chat.replyStyle → 지정 안 함(그 축은 지시를 싣지 않음).
// group 'speech' = 봇 자신이 어떤 말로 말하나(쓰는 말). 받아 주기와 같은 JSON 에 살지만 피커에서 따로 묶어 보인다.
//   stuck 축은 개입 강도 사다리가 '도움' 단에 오른 턴에만 실린다(서버 ActiveStepHandler).
// 언어 두 칸(챗 기본값에만): language = 대화 언어(레슨이 짜인 말) / support = 설명 언어(칭찬·안내·도움에 쓰는 말).
//   "연습하는 말"·"모국어"라는 이름은 버렸다 — 모국어는 대상마다 다르다(설계 project-le868/conversation-settings-design.md §3).

export const REPLY_AXES = [
	{
		key: "speech",
		label: "봇이 쓰는 말",
		group: "speech",
		options: [
			{ key: "target", label: "대화 언어로만 — 칭찬·안내까지 전부" },
			{ key: "mixed", label: "섞어서 — 안내는 설명 언어, 묻는 말은 대화 언어(옮기지 않음)" },
			{ key: "support", label: "설명 언어 위주 — 묻는 말에도 설명 언어 뜻을 곁들임" },
		],
	},
	{
		key: "stuck",
		label: "막혔을 때 쓰는 말",
		group: "speech",
		hint: "학습자가 막혀 도움을 주는 턴에만 적용돼요. 풀리면 위 기본값으로 돌아와요.",
		summaryPrefix: "막히면 ",
		options: [
			{ key: "support", label: "설명 언어로 풀어 도와주기 — 풀리면 다시 기본값으로" },
			{ key: "stay", label: "대화 언어로 계속 — 더 쉽고 짧게" },
		],
	},
	{
		key: "mistakes",
		label: "틀리거나 어색한 표현",
		options: [
			{ key: "ignore", label: "그냥 진행 — 뜻이 통하면 고치지 않음" },
			{ key: "recast", label: "고쳐 되받기 — 바른 표현으로 되받아 말하고 이어 감" },
			{ key: "retry", label: "고쳐 주고 따라 말하게 — 한 번 해 보게" },
			{ key: "explain", label: "고치고 짧게 설명 — 무엇이 달랐는지 한 마디" },
		],
	},
	{
		key: "otherLanguage",
		label: "대화 언어가 아닌 말로 답할 때",
		options: [
			{ key: "accept", label: "그대로 받기" },
			{ key: "model", label: "바꿔 들려주기 — 그 뜻을 대화 언어로" },
			{ key: "retry", label: "바꿔 들려주고 따라 말하게" },
		],
	},
	{
		key: "short",
		label: "아주 짧게 답할 때",
		options: [
			{ key: "accept", label: "그대로 받기" },
			{ key: "stretch", label: "한 번 더 늘려 보게 — 왜? 어떻게? 또 뭐?" },
		],
	},
	{
		// 목표로 인정하는 답 — 이해 판정이 목표 충족을 어떻게 셀지(서버 replyStyles credit → BlockSelector.assessStep).
		// 예전엔 목표 문구에 "완전한 문장으로"를 적어야 했다. 지정 안 함 = 내용이 나오면 인정.
		key: "credit",
		label: "목표로 인정하는 답",
		hint: "유도 스텝의 목표를 채운 걸로 셀 때의 기준이에요. '문장'을 고르면 낱말로 답할 때 AI가 문장으로 말해 보게 이끌어요.",
		options: [
			{ key: "content", label: "내용이 나오면 — 낱말·짧은 구도 인정" },
			{ key: "sentence", label: "완전한 문장으로 말해야 — 낱말만으론 안 됨" },
		],
	},
	{
		key: "offTopic",
		label: "이야기 밖으로 벗어날 때",
		options: [
			{ key: "brief", label: "짧게 받고 돌아오기" },
			{ key: "follow", label: "잠깐 따라가다 돌아오기" },
			{ key: "strict", label: "바로 돌아오기" },
		],
	},
];

// 피커에서 축을 묶어 보이는 단위. group 이 없는 축은 'reply'.
export const REPLY_GROUPS = [
	{ key: "speech", title: "봇이 쓰는 말", hint: "봇 자신이 어떤 말로 말할지. 비워 두면 캐릭터 설명(페르소나)에 적힌 대로예요." },
	{ key: "reply", title: "학습자 말 받아 주기", hint: "학습자가 이렇게 답했을 때 어떻게 받을지." },
];
export const axesOf = (group) => REPLY_AXES.filter((a) => (a.group || "reply") === group);

export const optionLabel = (axis, key) =>
	REPLY_AXES.find((a) => a.key === axis)?.options.find((o) => o.key === key)?.label || key;

// 접힌 머리글·요약 줄에 지금 고른 것을 짧게("영어(설명 한국어) · 섞어서 · 막히면 설명 언어로 … · 고쳐 되받기 …").
// 고른 게 없으면 "".
export const replySummary = (v) => {
	const r = readReply(v);
	if (!r) return "";
	const parts = REPLY_AXES.filter((a) => r[a.key]).map((a) => (a.summaryPrefix || "") + optionLabel(a.key, r[a.key]).split(" — ")[0]);
	const lang = r.language && r.support ? `${r.language}(설명 ${r.support})` : r.language || (r.support ? `설명 ${r.support}` : "");
	if (lang) parts.unshift(lang);
	return parts.join(" · ");
};

/** JSON 컬럼은 문자열로 올 수도 있다 */
export const readReply = (v) => {
	if (!v) return null;
	if (typeof v === "string") {
		try {
			const o = JSON.parse(v);
			return o && typeof o === "object" ? o : null;
		} catch {
			return null;
		}
	}
	return typeof v === "object" ? v : null;
};

/**
 * 아는 축·선택지만 남긴다. 아무것도 안 남으면 null(= 지정 안 함 — 스텝이면 필드를 지운다).
 * 언어 두 칸(language 대화 언어 · support 설명 언어)은 챗 기본값에만 있다.
 */
export const LANGUAGE_FIELDS = ["language", "support"];
export const normalizeReply = (o, { allowLanguage = false } = {}) => {
	const src = readReply(o) || {};
	const out = {};
	if (allowLanguage)
		for (const k of LANGUAGE_FIELDS) if (typeof src[k] === "string" && src[k].trim()) out[k] = src[k].trim().slice(0, 20);
	for (const ax of REPLY_AXES) if (src[ax.key] && ax.options.some((x) => x.key === src[ax.key])) out[ax.key] = src[ax.key];
	return Object.keys(out).length ? out : null;
};
